// HIG8 (GOALS/GOALS-DESIGN.html#hig8): the Mac menu bar carries the app's own
// commands. The desktop main process sends a command id to the renderer; the
// root route translates it here so the rails, the dock and the palette react
// without owning each other's state. Same shape as commandPaletteBus.
const DESK_COMMAND_EVENT = "cleo:desk-command";

export type DeskCommandId = "new-room" | "toggle-room-rail" | "toggle-context-rail";

export function dispatchDeskCommand(command: DeskCommandId): void {
  window.dispatchEvent(new CustomEvent<DeskCommandId>(DESK_COMMAND_EVENT, { detail: command }));
}

export function onDeskCommand(command: DeskCommandId, listener: () => void): () => void {
  const handler = (event: Event) => {
    if ((event as CustomEvent<DeskCommandId>).detail === command) listener();
  };
  window.addEventListener(DESK_COMMAND_EVENT, handler);
  return () => window.removeEventListener(DESK_COMMAND_EVENT, handler);
}
